import SummaryConfig from './summary/SummaryConfig';
import SettingsConfig from './settings/SettingsConfig';
import FeesChargesConfig from './fees-charges/FeesChargesConfig';
import TuitionPlansConfig from './tuition-plans/TuitionPlansConfig';
import DiscountsConfig from './discounts/DiscountsConfig';
import CategoriesConfig from './categories/CategoriesConfig';
import StripeOnboardingConfig from './stripe-onboarding/StripeOnboardingConfig';

const billingConfigs = [
	SummaryConfig,
	SettingsConfig,
	FeesChargesConfig,
	TuitionPlansConfig,
	DiscountsConfig,
	CategoriesConfig,
	StripeOnboardingConfig,
];

export default billingConfigs;
